module.exports = __webpack_public_path__ + "img/icon_cat_device.4f3ce4d.png";